// src/app/lang-change/lang-change.component.ts
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { LanguageDirectionService } from '../_services/language-direction.service';
import 'rxjs/add/operator/filter';

@Component({
  selector: 'lang-change',
  templateUrl: './lang-change.component.html',
  styleUrls: ['./lang-change.component.css'],
})
export class LangChangeComponent implements OnInit {
  url = '';
  username = '';
  currentLang = 'en';

  constructor(
    private router: Router,
    private directionService: LanguageDirectionService
  ) {
    router.events
      .filter((event): event is NavigationEnd => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this.url = event.url;
        this.updateCurrentLanguage();
      });
  }

  ngOnInit() {
    if (localStorage.getItem('currentUserId')) {
      this.username = JSON.parse(localStorage.getItem('currentUserId')!).username;
    }
    this.url = this.router.url;
    this.updateCurrentLanguage();
  }

  private updateCurrentLanguage() {
    const lang = this.getLanguageFromUrl();
    this.currentLang = lang;
    this.directionService.setLanguage(lang);
  }

  private getLanguageFromUrl(): string {
    // Use window.location.pathname to get the path after the hostname and port
    const path = window.location.pathname;

    // Split the path into segments and filter out empty ones
    const segments = path.split('/').filter(segment => segment && segment.length > 0);

    // The first segment (index 0) should be the language
    const lang = segments[0] || 'en'; // Use the first segment as the language, fallback to 'en'

    // Validate against known languages
    if (['fr', 'es', 'pt', 'ko', 'ar', 'en'].includes(lang)) {
      return lang;
    }
    return 'en'; // Default to 'en' if no match
  }
}



// WEBPACK FOOTER //
// ./src/app/lang-change/lang-change.component.ts